export class BacSearchForm {
  CountCourriers = true;
  FindRights: boolean;
  Ids: number[];
  Type: 'Entrant' | 'Traitement' | null;
  constructor(data?) {
    Object.assign(this, data);
  }
}

export class BacGetForm {
  Ids: number[];
  Type: 'Entrant' | 'Traitement' | null;
}
